const useCloudinaryUpload = () => {
  const t = async (file, folderName = '24hrdoc', filename = 'default') => {
    const form = new FormData();

    let blob = file;
    if (typeof file === 'string') {
      blob = await fetch(file).then((r) => r.blob());
    }

    form.append('file', blob, filename);
    form.append('upload_preset', 't8nurmrs');
    form.append('folder', folderName);

    const requestOptions = {
      method: 'POST',
      body: form,
    };
    let uploaded;
    try {
      const response = await fetch(
        `https://api.cloudinary.com/v1_1/${process.env.NEXT_PUBLIC_CLOUDINARY_CLOUD_NAME}/image/upload`,
        requestOptions
      );
      uploaded = await response.json();

      if (uploaded.error) {
        uploaded = undefined;
      }
    } catch {
      uploaded = undefined;
    }
    return uploaded;
  };
  return t;
};

export default useCloudinaryUpload;
